module.exports = __webpack_public_path__ + "static/wireframe-97f386b66a8db748ec114f24c66e687c.png";